// extracted by css-extract-rspack-plugin
export default {"skeletonContainer":"TemplateList-module__skeletonContainer__Gf5HPmF","templateHeader":"TemplateList-module__templateHeader__VBwsSpB"};